// Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import '../styles/Search.css'
import React, {useState, useEffect} from 'react';
import Magnify from "../images/magnifying.svg";
import { DEBOUNCE_DELAY } from '../constants/constants';

interface SearchCustomerHealthProps {
    onSearch: (query: string) => void;
    initialValue?: string;
}

export const SearchCustomerHealth: React.FC<SearchCustomerHealthProps> = ({ onSearch, initialValue }) => {

    const [inputValue, setInputValue] = useState(initialValue || "");

     useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            onSearch(inputValue);
        }, DEBOUNCE_DELAY); 

        return () => clearTimeout(delayDebounceFn);
    }, [inputValue]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setInputValue(newValue);
    };
   
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-7">
                    <form className="card card-sm search-bar" onSubmit={(e) => e.preventDefault()}>
                        <div className="card-body row no-gutters align-items-center">
                            <div className="col">
                                <input 
                                    className="form-control form-control-lg form-control-borderless"
                                    type="search" 
                                    placeholder="Search by Account Name" 
                                    value={inputValue}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-auto">
                                <img src={Magnify} alt="Search" className='magnify' />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <br />
        </div>
    );
};
